import script from "./DeliverStrategyPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DeliverStrategyPanel.vue?vue&type=script&setup=true&lang=js"

import "./DeliverStrategyPanel.vue?vue&type=style&index=0&id=3238871e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3238871e"]])

export default __exports__